import React, { Component } from "react";
import PropTypes from "prop-types";
import { HashRouter as Router, Route, NavLink, Switch } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSuitcase,
  faUsers,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import Kanban from "../Kanban";
import JobProfile from "../JobProfile";
import Agents from "../Agents";
import withTracker from "./withTracker";
import jobProfileType from "../JobProfile/types/jobProfileType";
import agentsType from "../Agents/types/agentsType";
import jobStatusWidgetType from "../JobProfile/types/jobStatusWidgetType";
import {
  RouterNav,
  RouterList,
  RouterItem,
  TabIcon,
  TabText,
  DotContainer,
  Dot,
  Ring,
} from "./styles/router-nav-styles";

const TrackedJobProfile = withTracker(JobProfile);
const TrackedAgents = withTracker(Agents);
const TrackedKanban = withTracker(Kanban);

class EmployerJobHubTabNavigation extends Component {
  constructor(props) {
    super(props);
    const { agents } = this.props;

    this.state = { agents };
  }

  updateAgentsTabContent = (agents) => {
    this.setState({ agents });
  };

  render() {
    const {
      jobProfile,
      getActionBarData,
      isRecruiter,
      jobStatusWidget,
      unreadApplicationsCount,
      isPortalEmployer,
      employerId,
      employerUserId,
    } = this.props;

    const { agents } = this.state;

    const { jobId } = jobProfile;

    const AgentsPage = (compProps) => (
      <TrackedAgents
        {...compProps}
        agents={agents}
        isPortalEmployer={isPortalEmployer}
        employerId={employerId}
        employerUserId={employerUserId}
      />
    );

    const KanbanPage = (compProps) => (
      <TrackedKanban {...compProps} isRecruiter={isRecruiter} jobId={jobId} />
    );

    const JobProfilePage = (compProps) => (
      <TrackedJobProfile
        {...compProps}
        jobProfile={jobProfile}
        getActionBarData={getActionBarData}
        jobStatusWidget={jobStatusWidget}
        isRecruiter={isRecruiter}
        isPortalEmployer={isPortalEmployer}
        updateAgentsTabContent={this.updateAgentsTabContent}
      />
    );

    return (
      <Router>
        <RouterNav id="tab-nav">
          <RouterList>
            <RouterItem>
              <NavLink to="/job-profile" activeClassName="active">
                <TabIcon>
                  <FontAwesomeIcon icon={faSuitcase} />
                </TabIcon>
                <TabText>Job Profile</TabText>
              </NavLink>
            </RouterItem>
            <RouterItem>
              {agents.awaiting.length > 0 && (
                <DotContainer>
                  <Dot />
                  <Ring agents />
                </DotContainer>
              )}
              <NavLink to="/agents">
                <TabIcon>
                  <FontAwesomeIcon icon={faUserCircle} />
                </TabIcon>
                <TabText>Agencies</TabText>
              </NavLink>
            </RouterItem>
            <RouterItem>
              {unreadApplicationsCount > 0 && (
                <DotContainer>
                  <Dot />
                  <Ring candidates />
                </DotContainer>
              )}
              <NavLink to="/candidates" data-test-id="candidates-tab-link">
                <TabIcon>
                  <FontAwesomeIcon icon={faUsers} />
                </TabIcon>
                <TabText>Candidates</TabText>
              </NavLink>
            </RouterItem>
          </RouterList>
        </RouterNav>
        <Switch>
          <Route exact path="/job-profile" render={JobProfilePage} />
          <Route path="/agents" render={AgentsPage} />
          <Route path="/candidates" render={KanbanPage} />
        </Switch>
      </Router>
    );
  }
}

EmployerJobHubTabNavigation.propTypes = {
  agents: agentsType.isRequired,
  getActionBarData: PropTypes.func.isRequired,
  isRecruiter: PropTypes.bool.isRequired,
  jobProfile: jobProfileType.isRequired,
  jobStatusWidget: jobStatusWidgetType.isRequired,
  unreadApplicationsCount: PropTypes.number.isRequired,
  isPortalEmployer: PropTypes.bool.isRequired,
  employerId: PropTypes.number.isRequired,
  employerUserId: PropTypes.number.isRequired,
};

export default EmployerJobHubTabNavigation;
